/**
 * Day / fleet BUTTONS explore page.
 *
 * Same read as the dataset page - the whole day at once, LEDs following the playhead - plus a source
 * selector, because a date has several boats and the table shows one at a time.
 *
 * Named Buttons.tsx, not FleetButtons.tsx: DAY_EXPLORE_FLEET_ALIAS in Sidebar.tsx only rewrites the six
 * legacy map/overlay/video/timeseries/scatter/probability names, so this resolves straight through.
 */
import ButtonsReportSection from "../../../../components/reports/ButtonsReportSection";

export default function DayButtonsPage(props: Record<string, unknown>) {
  return <ButtonsReportSection {...props} variant="fleet" />;
}
